// src/lib/kinema/core/layers/defineLayerType.ts
import type { LayerTypeDefinition, PropertyDefinition } from '../types';

export interface DefineLayerTypeInput {
  type: string;
  canHaveChildren?: boolean;
  renderable?: boolean;
  properties: Record<string, PropertyDefinition>;
  animatable?: string[];
  serialize?: LayerTypeDefinition['serialize'];
  deserialize?: LayerTypeDefinition['deserialize'];
}

export function defineLayerType(input: DefineLayerTypeInput): LayerTypeDefinition {
  return {
    type: input.type,
    canHaveChildren: input.canHaveChildren ?? false,
    renderable: input.renderable ?? true,
    properties: input.properties,
    animatable: input.animatable ?? [],
    serialize: input.serialize,
    deserialize: input.deserialize,
  };
}
